import { createLoader } from '@meteor/data-hooks';
import { userClient } from '../client';
import { userLoader } from './user';

export let userAuthProvidersLoader = createLoader({
  name: 'userAuthProviders',
  parents: [userLoader],
  fetch: () => userClient.userAuthProvider.list({}),
  mutators: {}
});

export let useUserAuthProviders = () => userAuthProvidersLoader.use();
